import { render, staticRenderFns } from "./SupplierLogsTemplate.vue?vue&type=template&id=26713877&scoped=true"
import script from "./SupplierLogsTemplate.vue?vue&type=script&lang=js"
export * from "./SupplierLogsTemplate.vue?vue&type=script&lang=js"
import style0 from "./SupplierLogsTemplate.vue?vue&type=style&index=0&id=26713877&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26713877",
  null
  
)

export default component.exports